<div class="practice-resources-container">
    <div class="practice-resources-header">
        <span class="practice-resources-title">{{ 'Home.practiceresources' | translate }}</span>
    </div>
    <div class="practice-resources-body">
       <span class="practice-resources-body-header">{{ 'Home.featuredresources' | translate }}</span>
       
        <div *ngIf="resourceList">
            <div class="practice-resources-item">
                <div *ngFor="let item of resourceList">
                    <h1 class="practice-resources-item-header">{{ item.title }}</h1>
                    <p class="practice-resources-item-body">{{ item.description }}</p>
                    <ul *ngIf="!!item.tags">
                        <li *ngFor="let tag of item.tags.tag">
                            {{ tag.name }} ({{ tag.color }})
                        </li>
                    </ul>
                    <!-- Removing the tags for now as they're not being supplied by content -->
                    <!-- <span class="practice-resources-tag infographic">Infographic</span>
                    <span class="practice-resources-tag new">New</span>
                    <span class="practice-resources-tag toolkit">Toolkit</span>
                    <span class="practice-resources-tag resource">Practice Resources</span> -->
                    <a class="practice-resources-learn"
                        [href]="item.link.href"
                        target="_blank"
                        (click)="resourceClick(item.link.href, item.link.text, item.title)">
                        {{ item.link.text }}
                    </a>
                </div>
            </div>        
        </div>
    <div class="practice-resources-footer">
        <a class="practice-resources-viewmore" target="_blank" href="" (click)="onViewMoreClick($event)">{{ 'Home.viewresources' | translate }}</a>
    </div>
</div>
